import { createContext } from 'react';

export const HeaderSizeContext = createContext<number>(106);
